var _defs, _path, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGeneratePin = function SvgGeneratePin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".generate-pin_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.713 10.34 3.5 14.49l3.205-3.838",
    className: "generate-pin_svg__a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.489 14.439a8.947 8.947 0 0 1 6.554-10.727 8.49 8.49 0 0 1 8.325 2.641M23.285 13.642 20.498 9.49l-3.205 3.838",
    className: "generate-pin_svg__a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.509 9.543a8.95 8.95 0 0 1-6.554 10.727 8.5 8.5 0 0 1-8.325-2.641",
    className: "generate-pin_svg__a"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 11.991,
    r: 2,
    className: "generate-pin_svg__a"
  })));
};
export default SvgGeneratePin;